module.exports = __webpack_public_path__ + "img/ggy.98f67a6f.svg";